import { DOWNLOAD_ANCHOR, LOGIN_URL, WAITLIST_PATH, X_URL } from '@/lib/landing'
import { GenieMark } from './primitives'

const COLUMNS = [
  {
    title: 'Product',
    links: [
      { label: 'Download for macOS', href: DOWNLOAD_ANCHOR },
      { label: 'Sign in to Genie cloud', href: LOGIN_URL },
      { label: 'Features', href: '#features' },
      { label: 'FAQ', href: '#faq' },
      { label: 'Report a bug', href: '/report-bug' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'X', href: X_URL },
      { label: 'Windows waitlist', href: WAITLIST_PATH },
      { label: 'hey@genie.art', href: 'mailto:hey@genie.art' },
    ],
  },
] as const

/** Dark grainy panel inset within the page gutter, as on magiclamp.genie.art. */
export function Footer() {
  return (
    <footer className="landing-shell pb-6">
      <div className="grain flex min-h-[360px] flex-col justify-between gap-12 rounded-[3px] bg-dark p-8 text-on-dark md:flex-row">
        <div className="relative z-10 flex flex-col justify-end">
          <span className="flex items-center gap-2.5">
            <GenieMark className="size-7" />
            <span className="display text-[24px] leading-none">Genie</span>
          </span>
          <p className="mt-3 max-w-sm text-[14px] leading-relaxed text-on-dark-2">
            An agentic creative studio. Open models on your Mac, a canvas you keep editing, cloud when you want it.
          </p>
          <p className="mono-label mt-8 text-on-dark-2">© {new Date().getFullYear()} Genie · genie.art</p>
        </div>
        <div className="relative z-10 grid grid-cols-2 gap-10 self-start text-[13px] md:self-end">
          {COLUMNS.map((col) => (
            <div key={col.title} className="flex flex-col gap-2">
              <span className="mb-1 text-on-dark">{col.title}</span>
              {col.links.map((l) => (
                <a key={l.href} href={l.href} className="text-on-dark-2 no-underline transition-colors hover:text-on-dark">
                  {l.label}
                </a>
              ))}
            </div>
          ))}
        </div>
      </div>
    </footer>
  )
}
